import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { CommonButtonTypes } from 'Common/Types/Types';
export const useStyles = makeStyles<Theme, CommonButtonTypes>((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			minWidth: 300,
			width: '95%',
			margin: '0 auto',
			[theme.breakpoints.down('xs')]: {
				height: '144px',
			},
		},
		menuHeaderBackground: {
			background: '#FFE6D9',
			height: '192.56px',
			width: '100%',
			fontFamily: 'Poppins',
		},
		mainCard: {
			[theme.breakpoints.down('xs')]: {
				height: '144px',
			},
		},
		menuHeaderImage: {
			margin: '-10rem auto 2rem',
			display: 'flex',
			justifyContent: 'center',
			[theme.breakpoints.down('xs')]: {
				width: '90%',
			},
		},
		listItems: {
			listStyleType: 'none',
			padding: 0,
			margin: 0,
		},
		type: {
			fontSize: '16px',
			color: '#78393D',
			padding: '0 1rem',
			margin: 0,
			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				fontSize: '16px',
			},
		},
		numberOfUpcoming: {
			fontSize: '16px',
			color: 'white',
			padding: '0 1rem',
			margin: 0,
			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				fontSize: '16px',
			},
		},
		greetings: {
			fontFamily: 'Poppins',
			color: '#78393D',
		},
		greetingInformation: {
			width: '80%',
			margin: '0 auto',
			fontFamily: 'Poppins',
			color: '#78393D',
			fontWeight: 'lighter',
		},
		links: {
			color: '#78393D)',
			textDecoration: 'none',
			width: '100%',
			'&:hover': {
				color: 'rgb(80 35 38)',
			},
		},
		description: {
			position: 'relative',
			padding: 0,
			width: '100%',
			justifyContent: 'space-evenly',
			fontSize: '16px',
			color: '#78393D',
			margin: '0',
			display: 'flex',
			fontFamily: 'Poppins',
			alignItems: 'center',
			fontWeight: 'lighter',
			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				fontSize: '14px',
			},
		},
		elements: {
			position: 'relative',
		},
		image: {
			position: 'relative',
			borderRadius: '1rem',
			zIndex: 1,
			width: ({ common }) => `${common?.width ? common?.width : 'inherit'}`,
			height: ({ common }) => `${common?.height ? common?.height : 'auto'}`,
			[theme.breakpoints.down('xs')]: {
				height: 'auto !important',
			},
		},
		imageButton: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			color: theme.palette.common.white,
			borderRadius: '2rem',
		},
		imageSrc: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			backgroundSize: 'cover',
			backgroundPosition: 'center 40%',
			borderRadius: '1rem',
		},
		imageBackdrop: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			backgroundColor: theme.palette.common.black,
			opacity: 0.4,
			transition: theme.transitions.create('opacity'),
			borderRadius: '1rem',
		},

		imageMarked: {
			height: 3,
			width: 18,
			backgroundColor: theme.palette.common.white,
			position: 'absolute',
			bottom: -2,
			left: 'calc(50% - 9px)',
			transition: theme.transitions.create('opacity'),
		},
		// mobile for upcoming menu
		hideNextButton: {
			[theme.breakpoints.down('xs')]: {
				display: 'none',
			},
		},
		cardSize: {
			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column !important',
			},
		},
		hideShowSideIconWeb: {
			display: 'block',
			[theme.breakpoints.down('xs')]: {
				display: 'none',
			},
		},
		hideShowSideIconMobile: {
			display: 'block',
			[theme.breakpoints.down('xs')]: {
				display: 'block',
			},
		},
	}),
);
